<footer class="text-white overflow-hidden">
  <!-- Main Footer Content -->
  <div class="container-max py-16 md:py-20">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
      <!-- Brand Column -->
      <div class="space-y-4">
        <div class="flex items-center gap-3">
          <img 
            src="/images/velora-infra-logo.png" 
            alt="Velora Infra Logo"
            class="h-14 w-auto"
          >
          <h3 class="text-2xl font-bold text-slate-900">Velora Infra</h3>
        </div>
        <p class="text-slate-700 text-sm leading-relaxed">
          Building trust, creating landmarks. Premium construction solutions for residential and commercial projects.
        </p>
        <!-- Social Links -->
        <div class="flex gap-4 pt-4">
          <a 
            *ngFor="let social of socialLinks"
            [href]="social.url"
            target="_blank"
            rel="noopener noreferrer"
            [title]="social.label"
            class="w-10 h-10 rounded-full bg-white/10 hover:bg-primary-500 flex items-center justify-center transition-all duration-300 transform hover:scale-110"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path *ngIf="social.icon === 'linkedin'" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              <path *ngIf="social.icon === 'facebook'" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              <path *ngIf="social.icon === 'instagram'" d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 22c-5.523 0-10-4.477-10-10S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm3.5-10c0 1.933-1.567 3.5-3.5 3.5S8.5 13.933 8.5 12 10.067 8.5 12 8.5s3.5 1.567 3.5 3.5z"/>
              <path *ngIf="social.icon === 'twitter'" d="M23.953 4.57a10 10 0 002.856-3.51 10 10 0 01-2.856.175 3.5 3.5 0 001.113-1.732c-.951.372-1.936.645-2.946.78a4.958 4.958 0 00-8.86 4.513C4.748 4.804 2.254 3.81 1.069 2.19c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096a4.929 4.929 0 01-2.24-.616v.06c0 2.409 1.713 4.417 3.964 4.882a4.935 4.935 0 01-2.236.084 4.964 4.964 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
            </svg>
          </a>
        </div>
      </div>

      <!-- Quick Navigation -->
      <div>
        <h4 class="text-lg font-semibold mb-6 text-slate-900">Navigation</h4>
        <nav class="space-y-3">
          <a 
            *ngFor="let item of menuItems"
            [routerLink]="item.route"
            class="block text-slate-700 hover:text-primary-600 transition-colors duration-300"
          >
            {{ item.label }}
          </a>
        </nav>
      </div>

      <!-- Quick Links -->
      <div>
        <h4 class="text-lg font-semibold mb-6 text-slate-900">Legal</h4>
        <nav class="space-y-3">
          <a 
            *ngFor="let link of quickLinks"
            [routerLink]="link.route"
            class="block text-slate-700 hover:text-primary-600 transition-colors duration-300"
          >
            {{ link.label }}
          </a>
        </nav>
      </div>

      <!-- Contact Information -->
      <div>
        <h4 class="text-lg font-semibold mb-6 text-slate-900">Get in Touch</h4>
        <div class="space-y-4">
          <div class="flex gap-3">
            <svg class="w-5 h-5 text-primary-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
            <div>
              <p class="text-sm text-slate-600">Email</p>
              <a href="mailto:contact@velorainfra.com" class="text-slate-800 hover:text-primary-600 transition-colors duration-300">
                contact@velorainfra.com
              </a>
            </div>
          </div>
          <div class="flex gap-3">
            <svg class="w-5 h-5 text-primary-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
            </svg>
            <div>
              <p class="text-sm text-slate-600">Phone</p>
              <a href="tel:+919503190050" class="text-slate-800 hover:text-primary-600 transition-colors duration-300">
                +919503190050
              </a>
            </div>
          </div>
          <div class="flex gap-3">
            <svg class="w-5 h-5 text-primary-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 21s-6-5.373-6-10a6 6 0 1112 0c0 4.627-6 10-6 10z"></path>
              <circle cx="12" cy="11" r="2.5" stroke-width="2"></circle>
            </svg>
            <div>
              <p class="text-sm text-slate-600">Address</p>
              <a href="https://maps.app.goo.gl/oLA1d1A1Mv4ahCr79" target="_blank" rel="noopener noreferrer" class="text-slate-800 hover:text-primary-600 transition-colors duration-300">
                Pune
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Divider -->
    <div class="border-t border-white/10"></div>

    <!-- Bottom Footer -->
    <div class="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-slate-700 text-sm">
      <p>&copy; {{ currentYear }} Velora Infra. All rights reserved.</p>
      <p>Designed & Built with <span class="text-primary-400">♥</span> by Velora Team</p>
    </div>
  </div>
</footer>
